import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import useGlobalSelectionsContext from './useGlobalSelectionsContext';
import { $can } from '../helpers/auth';

const useCanPermissions = () => {
  const { adminMode } = useGlobalSelectionsContext();
  const { permissions } = useSelector((state) => state.auth.auth);
  const isCan = (permission) => $can(permission, permissions, adminMode);

  /**
   * Check if the user can perform the given permission within the current initiative.
   *
   * permissions from the closure are filtered to only include the permissions
   * the user has for the current initiative.
   *
   * @param {string} permission - The permission to check.
   * @returns {boolean} True if the user can perform the permission within the current initiative, false otherwise.
   */
  const canWithinInitiative = useCallback(
    (permission) =>
      $can({ permission: permission, initiativeMode: true, adminMode: false }, permissions, false),
    [permissions],
  );

  return {
    isCan,
    canWithinInitiative,
  };
};

export default useCanPermissions;
